(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('zf-layout') !== '1' || !document.body.classList.contains('template-product')) return;

  const storageKey = 'zuofun-product-layout-tuner-v1';
  const defaults = {
    media: 60,
    gap: 58,
    mediaTop: 20,
    mediaBottom: 20,
    mediaLeft: 0,
    mediaRight: 0,
    galleryY: 2,
    thumbsX: 0,
    thumbsY: 4,
    thumbSize: 90,
    thumbGap: 12,
    thumbRadius: 6,
    imageScale: 104,
    imageX: 0,
    imageY: -36,
    infoX: -34,
    infoY: 4,
    infoWidth: 590,
    infoTop: 40,
    infoRight: 64,
    infoBottom: 80,
    infoLeft: 0,
    titleY: 0,
    titleSize: 30,
    ratingY: -4,
    priceY: -18,
    sizeY: -10,
    benefitsY: 0,
    quantityY: 0,
    quantityButtonSize: 34,
    quantityWidth: 90,
    buttonY: -12,
    buttonHeight: 52,
    buttonWidth: 100,
    buttonRadius: 40,
    paymentsY: -10,
    paymentsScale: 100,
    paymentsGap: 3,
    paymentIconHeight: 38,
    upsellY: -16,
    upsellTitleSize: 18,
    upsellImageSize: 104,
    upsellCardHeight: 90,
    upsellGap: 12,
    contentAlign: 'left',
    titleAlign: 'left',
    priceAlign: 'left',
    optionAlign: 'left',
    upsellAlign: 'left',
    titleRatingGap: 0,
    ratingPriceGap: 15,
    priceSizeGap: 10,
    sizeBenefitsGap: 18,
    benefitsQuantityGap: 28,
    quantityButtonGap: 30,
    buttonPaymentsGap: 18,
    paymentsUpsellGap: 28,
  };

  let saved = {};
  try {
    saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
  } catch (_) {
    saved = {};
  }
  if (typeof saved.top === 'number') {
    saved.mediaTop ??= saved.top;
    saved.mediaBottom ??= saved.top;
    saved.infoTop ??= saved.top;
  }
  if (typeof saved.rightInset === 'number') saved.infoRight ??= saved.rightInset;
  delete saved.top;
  delete saved.rightInset;
  const values = { ...defaults, ...saved };

  const controls = [
    ['basic', 'media', '图片区占比', 40, 62, 1, '%'],
    ['basic', 'gap', '两栏间距', 0, 120, 2, 'px'],
    ['frame', 'mediaTop', '图片区上边距', 0, 140, 2, 'px'],
    ['frame', 'mediaBottom', '图片区下边距', 0, 140, 2, 'px'],
    ['frame', 'mediaLeft', '图片区左边距', 0, 140, 2, 'px'],
    ['frame', 'mediaRight', '图片区右边距', 0, 140, 2, 'px'],
    ['frame', 'galleryY', '图片区整体上下', -100, 100, 2, 'px'],
    ['thumbs', 'thumbsX', '缩略图左右', -140, 140, 2, 'px'],
    ['thumbs', 'thumbsY', '缩略图上下', -140, 140, 2, 'px'],
    ['thumbs', 'thumbSize', '缩略图尺寸', 42, 120, 2, 'px'],
    ['thumbs', 'thumbGap', '缩略图间距', 0, 36, 1, 'px'],
    ['thumbs', 'thumbRadius', '缩略图圆角', 0, 30, 1, 'px'],
    ['mainImage', 'imageScale', '主图缩放', 70, 135, 1, '%'],
    ['mainImage', 'imageX', '主图左右', -140, 140, 2, 'px'],
    ['mainImage', 'imageY', '主图上下', -140, 140, 2, 'px'],
    ['info', 'infoX', '信息区整体左右', -140, 140, 2, 'px'],
    ['info', 'infoY', '信息区整体上下', -120, 120, 2, 'px'],
    ['info', 'infoWidth', '信息内容宽度', 360, 860, 10, 'px'],
    ['info', 'infoTop', '上 padding', 0, 140, 2, 'px'],
    ['info', 'infoRight', '右 padding', 0, 160, 2, 'px'],
    ['info', 'infoBottom', '下 padding', 0, 180, 2, 'px'],
    ['info', 'infoLeft', '左 padding', 0, 120, 2, 'px'],
    ['meta', 'titleY', '产品标题上下', -80, 80, 2, 'px'],
    ['meta', 'titleSize', '产品标题字号', 22, 52, 1, 'px'],
    ['meta', 'ratingY', '评分上下', -80, 80, 2, 'px'],
    ['meta', 'priceY', '价格区域上下', -80, 80, 2, 'px'],
    ['purchase', 'sizeY', '规格选择上下', -100, 100, 2, 'px'],
    ['purchase', 'benefitsY', '库存配送上下', -100, 100, 2, 'px'],
    ['quantity', 'quantityY', '数量模块上下', -100, 100, 2, 'px'],
    ['quantity', 'quantityButtonSize', '加减按钮尺寸', 28, 64, 2, 'px'],
    ['quantity', 'quantityWidth', '数量控件总宽', 90, 220, 2, 'px'],
    ['button', 'buttonY', '购买按钮上下', -120, 120, 2, 'px'],
    ['button', 'buttonHeight', '购买按钮高度', 44, 84, 2, 'px'],
    ['button', 'buttonWidth', '购买按钮宽度', 60, 100, 1, '%'],
    ['button', 'buttonRadius', '购买按钮圆角', 0, 42, 1, 'px'],
    ['payments', 'paymentsY', '支付图标上下', -100, 100, 2, 'px'],
    ['payments', 'paymentsScale', '支付图标整体缩放', 70, 130, 2, '%'],
    ['payments', 'paymentsGap', '支付图标间距', 0, 24, 1, 'px'],
    ['payments', 'paymentIconHeight', '单个图标高度', 20, 48, 1, 'px'],
    ['upsell', 'upsellY', '推荐模块上下', -160, 160, 2, 'px'],
    ['upsell', 'upsellTitleSize', '推荐标题字号', 13, 28, 1, 'px'],
    ['upsell', 'upsellImageSize', '推荐商品图尺寸', 70, 160, 2, 'px'],
    ['upsell', 'upsellCardHeight', '推荐卡片高度', 90, 190, 2, 'px'],
    ['upsell', 'upsellGap', '卡片内部间距', 0, 32, 1, 'px'],
    ['spacing', 'titleRatingGap', '标题 → 评分', 0, 60, 1, 'px'],
    ['spacing', 'ratingPriceGap', '评分 → 价格', 0, 60, 1, 'px'],
    ['spacing', 'priceSizeGap', '价格 → 规格', 0, 80, 1, 'px'],
    ['spacing', 'sizeBenefitsGap', '规格 → 库存配送', 0, 80, 1, 'px'],
    ['spacing', 'benefitsQuantityGap', '库存配送 → 数量', 0, 80, 1, 'px'],
    ['spacing', 'quantityButtonGap', '数量 → 购买按钮', 0, 80, 1, 'px'],
    ['spacing', 'buttonPaymentsGap', '购买按钮 → 支付图标', 0, 80, 1, 'px'],
    ['spacing', 'paymentsUpsellGap', '支付图标 → 加购推荐', 0, 100, 1, 'px'],
  ];

  const selectControls = [
    ['alignment', 'contentAlign', '信息区整体对齐'],
    ['alignment', 'titleAlign', '产品标题对齐'],
    ['alignment', 'priceAlign', '价格区域对齐'],
    ['alignment', 'optionAlign', '规格／库存／数量对齐'],
    ['alignment', 'upsellAlign', '加购推荐文字对齐'],
  ];

  document.body.classList.add('zuofun-layout-tuner');

  const style = document.createElement('style');
  style.textContent = `
    .zf-layout-tuner{position:fixed;z-index:99999;right:18px;top:92px;width:340px;height:calc(100vh - 110px);max-width:620px;max-height:calc(100vh - 20px);min-width:280px;min-height:180px;display:flex;flex-direction:column;padding:18px;background:rgba(255,255,255,.98);border:1px solid #d8d8d8;box-shadow:0 18px 48px rgba(0,0,0,.16);font:13px/1.35 Inter,Arial,sans-serif;color:#171717;overflow:hidden;resize:both}
    .zf-layout-tuner *{box-sizing:border-box}.zf-layout-tuner__head{display:flex;flex:0 0 auto;align-items:flex-start;justify-content:space-between;gap:12px;margin:-8px -8px 8px;padding:8px;cursor:move;user-select:none}.zf-layout-tuner__head-actions{display:flex;gap:4px}.zf-layout-tuner h2{margin:0;font-size:16px;line-height:1.2}.zf-layout-tuner p{margin:4px 0 0;color:#707070;font-size:11px}.zf-layout-tuner__close,.zf-layout-tuner__minimize{width:30px;min-height:30px!important;padding:0!important;border:0!important;background:none!important;font-size:20px!important;line-height:1;cursor:pointer!important}.zf-layout-tuner__controls{flex:1 1 auto;min-height:0;overflow-y:auto;padding-right:8px;scrollbar-gutter:stable}.zf-layout-tuner__group{margin-top:8px;border-top:1px solid #e6e6e6}.zf-layout-tuner__group:first-child{border-top:0}.zf-layout-tuner__group summary{padding:10px 0 4px;font-weight:700;cursor:pointer}.zf-layout-tuner__row{display:grid;grid-template-columns:1fr 58px;gap:6px 10px;align-items:center;margin:9px 0}.zf-layout-tuner__row label{font-weight:600}.zf-layout-tuner__value{text-align:right;color:#666;font-variant-numeric:tabular-nums}.zf-layout-tuner input[type=range]{grid-column:1/-1;width:100%;accent-color:#171717}.zf-layout-tuner__select-row{display:grid;grid-template-columns:1fr 120px;gap:10px;align-items:center;margin:10px 0}.zf-layout-tuner__select-row label{font-weight:600}.zf-layout-tuner__select-row select{width:100%;min-height:34px;border:1px solid #bbb;background:#fff;padding:0 8px;color:#171717}.zf-layout-tuner__actions{flex:0 0 auto;display:grid;grid-template-columns:1fr 1fr;gap:8px;margin:10px -18px -18px;padding:12px 18px 18px;background:#fff;border-top:1px solid #e6e6e6}.zf-layout-tuner button{min-height:34px;border:1px solid #171717;background:#fff;color:#171717;font:600 12px Inter,Arial,sans-serif;cursor:pointer}.zf-layout-tuner button[data-primary]{grid-column:1/-1;background:#171717;color:#fff}.zf-layout-tuner__status{grid-column:1/-1;min-height:16px;color:#555;font-size:11px;text-align:center}.zf-layout-tuner.is-minimized{height:auto!important;min-height:0;resize:none}.zf-layout-tuner.is-minimized .zf-layout-tuner__controls,.zf-layout-tuner.is-minimized .zf-layout-tuner__actions,.zf-layout-tuner.is-minimized .zf-layout-tuner__head p{display:none}.zf-layout-tuner.is-minimized .zf-layout-tuner__head{margin-bottom:-8px}
  `;
  document.head.appendChild(style);

  const panel = document.createElement('aside');
  panel.className = 'zf-layout-tuner';
  panel.setAttribute('aria-label', 'Product layout tuner');
  panel.innerHTML = `
    <div class="zf-layout-tuner__head"><div><h2>产品页布局调节板</h2><p>拖动标题栏移动 · 右下角缩放</p></div><div class="zf-layout-tuner__head-actions"><button class="zf-layout-tuner__minimize" type="button" aria-label="收起">−</button><button class="zf-layout-tuner__close" type="button" aria-label="关闭">×</button></div></div>
    <div class="zf-layout-tuner__controls"></div>
    <div class="zf-layout-tuner__actions"><button type="button" data-action="reset">重置</button><button type="button" data-action="copy">复制参数</button><button type="button" data-primary data-action="save">保存到本机</button><div class="zf-layout-tuner__status" aria-live="polite"></div></div>
  `;
  document.body.appendChild(panel);

  const controlsRoot = panel.querySelector('.zf-layout-tuner__controls');
  const status = panel.querySelector('.zf-layout-tuner__status');

  const apply = () => {
    const root = document.documentElement.style;
    root.setProperty('--zf-tuner-media-column', `${values.media}fr`);
    root.setProperty('--zf-tuner-info-column', `${100 - values.media}fr`);
    root.setProperty('--zf-tuner-column-gap', `${values.gap}px`);
    root.setProperty('--zf-tuner-media-top', `${values.mediaTop}px`);
    root.setProperty('--zf-tuner-media-bottom', `${values.mediaBottom}px`);
    root.setProperty('--zf-tuner-media-left', `${values.mediaLeft}px`);
    root.setProperty('--zf-tuner-media-right', `${values.mediaRight}px`);
    root.setProperty('--zf-tuner-gallery-y', `${values.galleryY}px`);
    root.setProperty('--zf-tuner-thumbs-x', `${values.thumbsX}px`);
    root.setProperty('--zf-tuner-thumbs-y', `${values.thumbsY}px`);
    root.setProperty('--zf-tuner-thumb-size', `${values.thumbSize}px`);
    root.setProperty('--zf-tuner-thumb-gap', `${values.thumbGap}px`);
    root.setProperty('--zf-tuner-thumb-radius', `${values.thumbRadius}px`);
    root.setProperty('--zf-tuner-image-scale', String(values.imageScale / 100));
    root.setProperty('--zf-tuner-image-x', `${values.imageX}px`);
    root.setProperty('--zf-tuner-image-y', `${values.imageY}px`);
    root.setProperty('--zf-tuner-info-x', `${values.infoX}px`);
    root.setProperty('--zf-tuner-info-y', `${values.infoY}px`);
    root.setProperty('--zf-tuner-info-width', `${values.infoWidth}px`);
    root.setProperty('--zf-tuner-info-top', `${values.infoTop}px`);
    root.setProperty('--zf-tuner-info-right', `${values.infoRight}px`);
    root.setProperty('--zf-tuner-info-bottom', `${values.infoBottom}px`);
    root.setProperty('--zf-tuner-info-left', `${values.infoLeft}px`);
    root.setProperty('--zf-tuner-title-y', `${values.titleY}px`);
    root.setProperty('--zf-tuner-title-size', `${values.titleSize}px`);
    root.setProperty('--zf-tuner-rating-y', `${values.ratingY}px`);
    root.setProperty('--zf-tuner-price-y', `${values.priceY}px`);
    root.setProperty('--zf-tuner-size-y', `${values.sizeY}px`);
    root.setProperty('--zf-tuner-benefits-y', `${values.benefitsY}px`);
    root.setProperty('--zf-tuner-quantity-y', `${values.quantityY}px`);
    root.setProperty('--zf-tuner-quantity-button-size', `${values.quantityButtonSize}px`);
    root.setProperty('--zf-tuner-quantity-width', `${values.quantityWidth}px`);
    root.setProperty('--zf-tuner-button-y', `${values.buttonY}px`);
    root.setProperty('--zf-tuner-button-height', `${values.buttonHeight}px`);
    root.setProperty('--zf-tuner-button-width', `${values.buttonWidth}%`);
    root.setProperty('--zf-tuner-button-radius', `${values.buttonRadius}px`);
    root.setProperty('--zf-tuner-payments-y', `${values.paymentsY}px`);
    root.setProperty('--zf-tuner-payments-scale', String(values.paymentsScale / 100));
    root.setProperty('--zf-tuner-payments-gap', `${values.paymentsGap}px`);
    root.setProperty('--zf-tuner-payment-icon-height', `${values.paymentIconHeight}px`);
    root.setProperty('--zf-tuner-upsell-y', `${values.upsellY}px`);
    root.setProperty('--zf-tuner-upsell-title-size', `${values.upsellTitleSize}px`);
    root.setProperty('--zf-tuner-upsell-image-size', `${values.upsellImageSize}px`);
    root.setProperty('--zf-tuner-upsell-card-height', `${values.upsellCardHeight}px`);
    root.setProperty('--zf-tuner-upsell-gap', `${values.upsellGap}px`);
    const flexAlign = { left: 'flex-start', center: 'center', right: 'flex-end' };
    const gridAlign = { left: 'start', center: 'center', right: 'end' };
    root.setProperty('--zf-tuner-content-align', values.contentAlign);
    root.setProperty('--zf-tuner-content-flex-align', flexAlign[values.contentAlign]);
    root.setProperty('--zf-tuner-title-align', values.titleAlign);
    root.setProperty('--zf-tuner-price-align', values.priceAlign);
    root.setProperty('--zf-tuner-price-flex-align', flexAlign[values.priceAlign]);
    root.setProperty('--zf-tuner-price-grid-align', gridAlign[values.priceAlign]);
    root.setProperty('--zf-tuner-option-align', values.optionAlign);
    root.setProperty('--zf-tuner-option-flex-align', flexAlign[values.optionAlign]);
    root.setProperty('--zf-tuner-upsell-align', values.upsellAlign);
    root.setProperty('--zf-tuner-title-rating-gap', `${values.titleRatingGap}px`);
    root.setProperty('--zf-tuner-rating-price-gap', `${values.ratingPriceGap}px`);
    root.setProperty('--zf-tuner-price-size-gap', `${values.priceSizeGap}px`);
    root.setProperty('--zf-tuner-size-benefits-gap', `${values.sizeBenefitsGap}px`);
    root.setProperty('--zf-tuner-benefits-quantity-gap', `${values.benefitsQuantityGap}px`);
    root.setProperty('--zf-tuner-quantity-button-gap', `${values.quantityButtonGap}px`);
    root.setProperty('--zf-tuner-button-payments-gap', `${values.buttonPaymentsGap}px`);
    root.setProperty('--zf-tuner-payments-upsell-gap', `${values.paymentsUpsellGap}px`);
  };

  const updateDisplays = () => {
    controls.forEach(([, key, , , , , unit]) => {
      const output = panel.querySelector(`[data-value="${key}"]`);
      const input = panel.querySelector(`[data-control="${key}"]`);
      if (output) output.textContent = `${values[key]}${unit}`;
      if (input) input.value = values[key];
    });
    selectControls.forEach(([, key]) => {
      const select = panel.querySelector(`[data-select-control="${key}"]`);
      if (select) select.value = values[key];
    });
  };

  const groupLabels = {
    basic: '基础布局',
    frame: '图片区外框与 Padding',
    thumbs: '缩略图',
    mainImage: '主产品图',
    info: '信息区外框与 Padding',
    meta: '标题、评分与价格',
    purchase: '规格与库存配送',
    quantity: '数量控件',
    button: '购买按钮',
    payments: '支付图标',
    upsell: '加购推荐',
    alignment: '文字与内容对齐',
    spacing: '模块之间的行间距',
  };
  const groups = {};
  controls.forEach(([group, key, label, min, max, step, unit]) => {
    if (!groups[group]) {
      const details = document.createElement('details');
      details.className = 'zf-layout-tuner__group';
      details.open = group === 'basic';
      details.innerHTML = `<summary>${groupLabels[group]}</summary><div></div>`;
      controlsRoot.appendChild(details);
      groups[group] = details.querySelector('div');
    }
    const row = document.createElement('div');
    row.className = 'zf-layout-tuner__row';
    row.innerHTML = `<label for="zf-tuner-${key}">${label}</label><output class="zf-layout-tuner__value" data-value="${key}">${values[key]}${unit}</output><input id="zf-tuner-${key}" data-control="${key}" type="range" min="${min}" max="${max}" step="${step}" value="${values[key]}">`;
    groups[group].appendChild(row);
    row.querySelector('input').addEventListener('input', (event) => {
      values[key] = Number(event.currentTarget.value);
      updateDisplays();
      apply();
      status.textContent = '';
    });
  });

  selectControls.forEach(([group, key, label]) => {
    if (!groups[group]) {
      const details = document.createElement('details');
      details.className = 'zf-layout-tuner__group';
      details.innerHTML = `<summary>${groupLabels[group]}</summary><div></div>`;
      controlsRoot.appendChild(details);
      groups[group] = details.querySelector('div');
    }
    const row = document.createElement('div');
    row.className = 'zf-layout-tuner__select-row';
    row.innerHTML = `<label for="zf-tuner-${key}">${label}</label><select id="zf-tuner-${key}" data-select-control="${key}"><option value="left">左对齐</option><option value="center">居中</option><option value="right">右对齐</option></select>`;
    groups[group].appendChild(row);
    const select = row.querySelector('select');
    select.value = values[key];
    select.addEventListener('change', (event) => {
      values[key] = event.currentTarget.value;
      apply();
      status.textContent = '';
    });
  });

  panel.querySelector('[data-action="save"]').addEventListener('click', () => {
    localStorage.setItem(storageKey, JSON.stringify(values));
    status.textContent = '已保存；下次打开调节板会自动恢复。';
  });
  panel.querySelector('[data-action="reset"]').addEventListener('click', () => {
    Object.assign(values, defaults);
    localStorage.removeItem(storageKey);
    updateDisplays();
    apply();
    status.textContent = '已恢复默认参数。';
  });
  panel.querySelector('[data-action="copy"]').addEventListener('click', async () => {
    const text = JSON.stringify(values);
    try {
      await navigator.clipboard.writeText(text);
      status.textContent = '参数已复制。';
    } catch (_) {
      status.textContent = text;
    }
  });
  panel.querySelector('.zf-layout-tuner__close').addEventListener('click', () => panel.remove());
  panel.querySelector('.zf-layout-tuner__minimize').addEventListener('click', (event) => {
    event.stopPropagation();
    const minimized = panel.classList.toggle('is-minimized');
    event.currentTarget.textContent = minimized ? '+' : '−';
    event.currentTarget.setAttribute('aria-label', minimized ? '展开' : '收起');
  });

  const dragHandle = panel.querySelector('.zf-layout-tuner__head');
  dragHandle.addEventListener('pointerdown', (event) => {
    if (event.target.closest('button')) return;
    const rect = panel.getBoundingClientRect();
    const startX = event.clientX;
    const startY = event.clientY;
    const startLeft = rect.left;
    const startTop = rect.top;
    panel.style.right = 'auto';
    panel.style.left = `${startLeft}px`;
    panel.style.top = `${startTop}px`;
    dragHandle.setPointerCapture(event.pointerId);
    const move = (moveEvent) => {
      const maxLeft = Math.max(0, window.innerWidth - panel.offsetWidth);
      const maxTop = Math.max(0, window.innerHeight - 44);
      panel.style.left = `${Math.min(maxLeft, Math.max(0, startLeft + moveEvent.clientX - startX))}px`;
      panel.style.top = `${Math.min(maxTop, Math.max(0, startTop + moveEvent.clientY - startY))}px`;
    };
    const stop = () => {
      dragHandle.removeEventListener('pointermove', move);
      dragHandle.removeEventListener('pointerup', stop);
      dragHandle.removeEventListener('pointercancel', stop);
    };
    dragHandle.addEventListener('pointermove', move);
    dragHandle.addEventListener('pointerup', stop);
    dragHandle.addEventListener('pointercancel', stop);
  });

  updateDisplays();
  apply();
})();
